import React from "react";

interface SpinnerProps {
  size?: number;
  className?: string;
}

export default function Spinner({ size = 16, className = "" }: SpinnerProps) {
  return (
    <img
      src="/assets/hsip_spinner.gif"
      alt=""
      aria-hidden
      width={size}
      height={size}
      className={`inline-block flex-shrink-0 ${className}`}
    />
  );
}
